var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlansInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plans-inactive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.99778527,4.00221473 L14.2370916,4.00221473 C16.4462306,4.00221473 18.2370916,5.79307574 18.2370916,8.00221473 L18.2370916,14.0022147 C18.2370916,16.2113537 16.4462306,18.0022147 14.2370916,18.0022147 L6.99778527,18.0022147 C4.78864627,18.0022147 2.99778527,16.2113537 2.99778527,14.0022147 L2.99778527,8.00221473 C2.99778527,5.79307574 4.78864627,4.00221473 6.99778527,4.00221473 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08811387,0.586446681 L8.61514262,0.586446681 C9.31670253,0.586446681 9.88542921,1.15517336 9.88542921,1.85673327 C9.88542921,1.98154894 9.86703357,2.10568315 9.83083524,2.22513452 L9.53003244,3.21775805 C9.40303086,3.6368524 9.41709025,4.08604674 9.57005215,4.49637847 L10.0220453,5.70888382 C10.2167345,6.23115213 10.1846496,6.81097233 9.93352505,7.30857111 L9.75061614,7.67100189 C9.48645715,8.19442827 9.46527904,8.80740435 9.69268286,9.34781405 L9.83083524,9.67612377 C10.1241699,10.3732137 9.91567181,11.1803736 9.3214285,11.6481926 L8.33673489,12.4233941 C7.4332236,13.1346847 6.2026363,13.2669447 5.1686112,12.7638949 L4.08811387,12.2382365 L4.08811387,0.586446681 Z",
    id: "path-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plans-inactive",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(19.173394, 21.637495) rotate(-45.000000) translate(-19.173394, -21.637495) translate(3.673394, 2.137495)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(15.500000, 16.000000) rotate(-45.000000) translate(-15.500000, -16.000000) translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    transform: "translate(10.617438, 11.002215) rotate(45.000000) translate(-10.617438, -11.002215) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M6.99778527,5.00221473 C5.34093102,5.00221473 3.99778527,6.34536048 3.99778527,8.00221473 L3.99778527,14.0022147 C3.99778527,15.659069 5.34093102,17.0022147 6.99778527,17.0022147 L14.2370916,17.0022147 C15.8939458,17.0022147 17.2370916,15.659069 17.2370916,14.0022147 L17.2370916,8.00221473 C17.2370916,6.34536048 15.8939458,5.00221473 14.2370916,5.00221473 L6.99778527,5.00221473 Z",
    strokeLinejoin: "square",
    fillOpacity: 0.15,
    fill: "#2E2B2B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2B2B",
    strokeWidth: 1,
    d: "M6.99778527,4.50221473 C5.06478864,4.50221473 3.49778527,6.06921811 3.49778527,8.00221473 L3.49778527,14.0022147 C3.49778527,15.9352114 5.06478864,17.5022147 6.99778527,17.5022147 L14.2370916,17.5022147 C16.1700882,17.5022147 17.7370916,15.9352114 17.7370916,14.0022147 L17.7370916,8.00221473 C17.7370916,6.06921811 16.1700882,4.50221473 14.2370916,4.50221473 L6.99778527,4.50221473 Z",
    strokeLinejoin: "square"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    stroke: "#2E2B2B",
    fill: "#FFFFFF",
    cx: 11.9142136,
    cy: 10.0857864,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(15.993903, 28.150758) rotate(-45.000000) translate(-15.993903, -28.150758) translate(8.493903, 21.150758)",
    strokeLinejoin: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2",
    transform: "translate(7.207767, 7.086447) rotate(45.000000) translate(-7.207767, -7.086447) "
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    d: "M5.08811387,1.58644668 L5.08811387,11.6126725 L5.60608434,11.8646634 C6.29543441,12.20003 7.11582595,12.1118566 7.71816681,11.6376629 L8.70286042,10.8624613 C8.94346609,10.6730442 9.02788578,10.3462298 8.90911625,10.0639821 L8.77096387,9.73567241 C8.42985814,8.92505786 8.46162531,8.00559374 8.85786379,7.22045418 L9.0407727,6.8580234 C9.16633495,6.60922401 9.18237741,6.31931391 9.08503281,6.05817975 L8.63303969,4.84567441 C8.40359684,4.23017681 8.38250775,3.55638529 8.57301012,2.92774377 L8.87381292,1.93512024 C8.88151506,1.90970385 8.88542921,1.88329106 8.88542921,1.85673327 C8.88542921,1.70745811 8.76441778,1.58644668 8.61514262,1.58644668 L5.08811387,1.58644668 Z",
    fillOpacity: 0.15,
    fill: "#2E2B2B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2B2B",
    strokeWidth: 1,
    d: "M4.58811387,1.08644668 L4.58811387,11.9254545 L5.38734777,12.3142792 C6.24903536,12.7334873 7.27452477,12.6232707 8.02745085,12.0305285 L9.01214446,11.2553269 C9.42956895,10.9267089 9.57602786,10.3597218 9.36997575,9.87005295 L9.23182337,9.54174323 C8.94756859,8.86623111 8.97404123,8.100011 9.30423996,7.44572804 L9.48714887,7.08329726 C9.67549226,6.71009817 9.69955593,6.27523302 9.55353904,5.88353179 L9.10154592,4.67102644 C8.91034355,4.15811177 8.8927693,3.59661885 9.05152128,3.07275091 L9.35232408,2.08012738 C9.37427431,2.0076935 9.38542921,1.93242 9.38542921,1.85673327 C9.38542921,1.43131574 9.04056016,1.08644668 8.61514262,1.08644668 L4.58811387,1.08644668 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansInactive);
export default __webpack_public_path__ + "static/media/plans-inactive.a80adf996049bca6e392298509dc13a0.svg";
export { ForwardRef as ReactComponent };